import React from "react";
import {
  IconAlertTriangle,
  IconCircleCheck,
  IconFolderOpen,
  IconProgressAlert,
  IconStatusChange,
} from "@tabler/icons-react";
import { DeviceLogSeverity } from "./deviceLogUtils";

export const DEVICE_LOG_SEVERITY_ICON: Record<DeviceLogSeverity, React.ReactNode> = {
  error: <IconAlertTriangle size="1rem" />,
  success: <IconCircleCheck size="1rem" />,
  progress: <IconProgressAlert size="1rem" />,
  info: <IconStatusChange size="1rem" />,
  unknown: <IconFolderOpen size="1rem" />,
};
